var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "inner" },
    _vm._l(_vm.collections, function(item) {
      return _c(
        "div",
        { key: item.id, staticClass: "item" },
        [
          _c(
            "span",
            {
              staticClass: "name",
              class: { changed: item.modified },
              on: {
                click: function($event) {
                  return _vm.toggle(item.id)
                }
              }
            },
            [
              _c("b-icon", {
                class: "clipboard-list",
                attrs: { icon: "clipboard-list", pack: "fas", size: "is-small" }
              }),
              _vm._v("\n      " + _vm._s(item.name) + "\n      "),
              !_vm.isCollectionMembersRead(item)
                ? _c("span", { staticClass: "unread" }, [
                    _vm._v("\n        *\n      ")
                  ])
                : _vm._e(),
              item.documentsTotal > 0
                ? [
                    _c("span", {
                      staticClass: "tag is-rounded is-small",
                      domProps: { textContent: _vm._s(item.documentsTotal) }
                    }),
                    item.documentsTotal - item.documentsReadCount > 0
                      ? _c("span", {
                          staticClass: "tag is-rounded is-primary",
                          domProps: {
                            textContent: _vm._s(
                              item.documentsTotal - item.documentsReadCount
                            )
                          }
                        })
                      : _vm._e()
                  ]
                : _vm._e()
            ],
            2
          ),
          item.documents.length > 0 && _vm.expanded.indexOf(item.id) !== -1
            ? _c("PortefeuilleArboDocs", {
                attrs: {
                  id: _vm.id,
                  level: _vm.level,
                  documents: item.documents
                }
              })
            : _vm._e()
        ],
        1
      )
    }),
    0
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }